import React, {useEffect} from "react";
import {Button, Col, DatePicker, Form, Image, Input, message, Row, Upload, UploadProps} from "antd";
import {useStore} from "../../../store";
import {addAtlasInfo, editAtlasInfo, uploadSpecimenPictureApi} from "../../../http/manager";
import {observer} from "mobx-react";
import styled from "styled-components";
import {BaseImageUrl} from "../../../http/http";
import {UploadOutlined} from "@ant-design/icons";
import moment from "moment/moment";
import {DetailType, ManagerBusinessType} from "../../../common/Constant";
import {forEach} from "lodash";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../../config/serviceLoading";

const defaultIcon = require("../../../image/default-pic.png")

interface ImageProps {
    onSuccess: () => void;
}

const ImageEdit: React.FC<ImageProps> = ({onSuccess}) => {

    const [form] = Form.useForm();
    const {imageLibraryStore} = useStore();

    useEffect(() => {
        if (imageLibraryStore.detailType === DetailType.EDIT) {
            const {detailEntity} = imageLibraryStore;
            const detail = JSON.parse(JSON.stringify(detailEntity));
            if (detail && detail.sequenceTime) {
                detail.sequenceTime = moment(detail.sequenceTime)
            }
            form.setFieldsValue(detail);
        }
        imageLibraryStore.srcFile = null
        imageLibraryStore.clearFileList();
        // return form.resetFields();
    }, []);

    const submit = () => {
        const formFields = form.getFieldsValue(true);
        const formKeys = Object.keys(formFields);
        if (imageLibraryStore.detailType === DetailType.ADD && imageLibraryStore.fileList.length <= 0) {
            message.error("请选择照片");
            return;
        }
        form.validateFields()
            .then((values) => {
                const formData = new FormData();
                forEach(formKeys, (key) => {
                    if (key === "sequenceTime") {
                        formData.append(key, moment(formFields[key]).format("YYYY-MM-DD"))
                    } else {
                        formData.append(key, formFields[key]);
                    }
                })
                showFullScreenLoading()

                if (imageLibraryStore.detailType === "add") {
                    addAtlasInfo(formData)
                        .then((res) => {
                            if (Number(res.code) === 200) {
                                uploadPicture(res.data);
                            } else {
                                tryHideFullScreenLoading();
                                message.error("新增失败");
                            }
                        }).catch(() => {
                        message.error("新增失败");
                        tryHideFullScreenLoading()
                    })
                } else {
                    editAtlasInfo(formData)
                        .then((res) => {
                            if (Number(res.code) === 200) {
                                if (imageLibraryStore.fileList.length <= 0) {
                                    message.success("编辑成功");
                                    tryHideFullScreenLoading()
                                    console.log("dtl----sucess2")
                                    onSuccess();
                                } else {
                                    uploadPicture(res.data, false);
                                }
                            } else {
                                tryHideFullScreenLoading();
                                message.error("编辑失败");
                            }
                        }).catch(() => {
                        message.error("编辑失败");
                        tryHideFullScreenLoading()
                    })
                }
            })
            .catch();
    }

    const uploadPicture = (data: any, isAdd = true) => {
        const params = new FormData();
        if (imageLibraryStore.detailType === "edit") {
            params.append("id", String(imageLibraryStore.detailEntity!.id));
        } else {
            params.append("id", data.id);
        }
        params.append("type", ManagerBusinessType.ATLAS+"")
        params.append("file", imageLibraryStore.fileList[0]);
        uploadSpecimenPictureApi(params)
            .then((res) => {
                tryHideFullScreenLoading()
                if (Number(res.code) === 200) {
                    message.success(isAdd ? "新增成功" : "编辑成功");
                    console.log("dtl----sucess1")
                    onSuccess();
                } else {
                    message.error(isAdd ? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
                }
            }).catch(() => {
            message.error(isAdd ? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
            tryHideFullScreenLoading()
        })
    }

    const props: UploadProps = {
        onRemove: (file) => {
        },
        beforeUpload: (file) => {
            imageLibraryStore.setFilelist(file);
            fileToBase(file);
            return false;
        },
    };

    const fileToBase = (file: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            imageLibraryStore.srcFile = reader.result;
        }
    }

    return (<Wrapper>
        <Form title={"基础库编辑"} form={form} layout={"vertical"} size={"middle"}
              style={{maxHeight: "400px", overflowY: "auto", overflowX: "hidden"}}>
            <Row gutter={24}>
                <Col span={8}><Form.Item label={"图谱编号"} name={"atlasNumber"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"采样编号"} name={"sampleNumber"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"药材名"} name={"medicineName"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"基原植物"} name={"originalPlant"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"拉丁名"} name={"latinName"} rules={[{required: true}]} required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"样品来源"} name={"sampleSource"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"取样部位"} name={"smapleLocation"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"样品提供单位"} name={"sampleUnit"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"鉴定人"} name={"appraiser"} required={false}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"责任人"} name={"dutyPerson"}
                                         required={false}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"序列提交时间"} name={"sequenceTime"}
                                         required={false}><DatePicker/></Form.Item></Col>
                <Col span={8}><Form.Item label={"图谱类型"} name={"atlasType"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"采集信息"} name={"collectInfo"}
                                         required={false}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"描述信息"} name={"describeInfo"} required={false}><Input/></Form.Item></Col>
                <Col span={8}>
                    <Upload style={{marginTop: "15px", marginBottom: "15px"}} showUploadList={false} name={"picture"}
                            maxCount={1} listType="picture-card" {...props} >
                        {(imageLibraryStore.detailEntity?.imgUrl || imageLibraryStore.srcFile) ? <Image preview={false}
                                                                                                        src={imageLibraryStore.srcFile ? imageLibraryStore.srcFile : BaseImageUrl + imageLibraryStore.detailEntity?.imgUrl}
                                                                                                        fallback={defaultIcon}/> :
                            <UploadOutlined/>}
                    </Upload>
                </Col>
            </Row>
        </Form>
        <Button onClick={submit} type={"primary"} style={{width: "70px", left: "630px"}}>提交</Button>
    </Wrapper>);
}

export default observer(ImageEdit)

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    padding: 20px 0 20px 0;
  }
`;
